import { EXTERNAL_URLS } from "@constants/api.urls";

import { isProdEnv } from "@utils/appUtils";
import DupontLogger from "@utils/DupontLogger";

const Logger = DupontLogger("Engagement API");

/**
 * Sends engagement data as form data to the DuPont engagement endpoint.
 * Fixed fields (formId, owningOrganization, webVisitorID, engagementURL, engagementSource)
 * are merged with the caller-supplied payload.
 *
 * @param {string} emailAddress - Email address of the user.
 */
export const sendEngagement = payload => {
  if (!isProdEnv()) {
    Logger.info("Not capturing Engagement payload on DEV/SIT environment:");
    return;
  }

  const data = {
    ...payload,
    formId: "1001",
    owningOrganization: "WS",
    webVisitorID: "0000-0000-0000",
    engagementURL: location.origin,
    engagementSource: `WAVE PRO ${import.meta.env.VITE_PROJECT_ENV}`,
  };

  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  fetch(EXTERNAL_URLS.engagementURL, { method: "POST", body: formData })
    .then(response => {
      if (!response.ok) {
        Logger.error(`EngagementURL HTTP error! status: ${response.status}`);
      }
    })
    .catch(error => {
      Logger.error("EngagementURL error:", error);
    });
};
